/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { PropertyResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ShowPublicPropertyServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Show public property
     * 
     * @param property The property ID
     */
    getPublicProperty(property: number, extraHttpRequestParams?: any): Observable<PropertyResource>;

}
